// extracted by mini-css-extract-plugin
module.exports = {"footer":"Reviews_footer__3Pt4l","header":"Reviews_header__3J_tu","review":"Reviews_review__341Qo","photo":"Reviews_photo__3RvwI","content":"Reviews_content__2uxn-"};